export const mockUserObject = {
  staff1: {
      firstName: "Alexander",
      greetingName: "Alexander",
      deptClass: "CS Project Management",
      netid: "f001gqb",
      displayName: "Alexander F. French",
      email: "Alexander.F.French@Dartmouth.edu",
      personalEmail: "aff@mit.edu",
      primaryAffiliation: "Staff",
      verificationOptions: [
          {
              type: "email",
              verificationOptionId: "personalEmail",
              value: "a*****f@mit.edu"
          }
      ]
  },
  staff2: {
      firstName: "Quinn",
      greetingName: "Quinn",
      deptClass: "Web Strategy & Design",
      netid: "dz10028",
      displayName: "Quinn Palmer",
      email: "quinn.palmer@dartmouth.edu",
      personalEmail: "myaccount.test_email@yahoo.com",
      primaryAffiliation: "Staff",
      verificationOptions: [
          {
              type: "email",
              verificationOptionId: "personalEmail",
              value: "m*****l@yahoo.com"
          }
      ],
  },
  alumnus: {
    firstName: "Mackenzie",
    greetingName: "Mackenzie",
    deptClass: "AAAS",
    netid: "f000001",
    displayName: "Mackenzie James",
    email: "mackenzie.james@dartmouth.edu",
    personalEmail: "mackenzie.james68@yahoo.com",
    primaryAffiliation: "alum",
    verificationOptions: [
        {
            type: "email",
            verificationOptionId: "personalEmail",
            value: "m*****8@gmail.com"
        }
    ],
}
};